import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  articleType: belongsTo('category', { inverse: null }),
  artist: belongsTo('artist', { inverse: null }),
  channel: belongsTo('channel', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
});
